module.exports = __webpack_public_path__ + "img/plain.be5030ca.webp";